import React from 'react';
import { Box, HStack, Text, Tooltip } from '@chakra-ui/react';
import { Icon } from '@app/components/Icon';

export const PointsBadge = () => {
  return (
    <Tooltip
      label={
        <Box
          sx={{
            padding: 4,
            backgroundColor: 'gray.1',
            borderRadius: 2,
            color: 'orange'
          }}
        >
          Points
        </Box>
      }
      portalProps={{ appendToParentPortal: true }}
      placement="top"
      zIndex={1000}
    >
      <HStack gap={2} alignItems="center">
        <Icon
          name="flame"
          style={{ color: 'var(--chakra-colors-orange)', width: '24px' }}
        />
        <Text
          fontSize="12px"
          // fontWeight={500}
          color="orange"
          sx={{
            border: '1px solid',
            borderColor: 'orange',
            borderRadius: '4px',
            padding: '2px 4px'
          }}
        >
          Points
        </Text>
      </HStack>
    </Tooltip>
  );
};
